import { componentQrl, inlinedQrl, useContext, _jsxC, Slot, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import builderContext from "../../context/builder.context.qwik.mjs";
import ComponentsContext from "../../context/components.context.qwik.mjs";
import { Block } from "../block/block.qwik.mjs";
import { BlocksWrapper } from "./blocks-wrapper.qwik.mjs";
const Blocks = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const builderContext$1 = useContext(builderContext);
  const componentsContext = useContext(ComponentsContext);
  return /* @__PURE__ */ _jsxC(BlocksWrapper, {
    get blocks() {
      return props.blocks;
    },
    get parent() {
      return props.parent;
    },
    get path() {
      return props.path;
    },
    get styleProp() {
      return props.styleProp;
    },
    get BlocksWrapperProps() {
      var _a;
      return props.BlocksWrapperProps || ((_a = props.context) == null ? void 0 : _a.BlocksWrapperProps) || (builderContext$1 == null ? void 0 : builderContext$1.BlocksWrapperProps);
    },
    get classNameProp() {
      return props.className;
    },
    get BlocksWrapper() {
      var _a;
      return ((_a = props.context) == null ? void 0 : _a.BlocksWrapper) || (builderContext$1 == null ? void 0 : builderContext$1.BlocksWrapper);
    },
    children: [
      /* @__PURE__ */ _jsxC(Slot, null, 3, "0n_0"),
      props.blocks ? (props.blocks || []).map((block) => {
        return /* @__PURE__ */ _jsxC(Block, {
          block,
          get linkComponent() {
            return props.linkComponent;
          },
          get context() {
            return props.context || builderContext$1;
          },
          get registeredComponents() {
            return props.registeredComponents || (componentsContext == null ? void 0 : componentsContext.registeredComponents);
          },
          [_IMMUTABLE]: {
            context: _fnSignal((p0, p1) => p1.context || p0, [
              builderContext$1,
              props
            ], "p1.context||p0"),
            linkComponent: _fnSignal((p0) => p0.linkComponent, [
              props
            ], "p0.linkComponent"),
            registeredComponents: _fnSignal((p0, p1) => p1.registeredComponents || (p0 == null ? void 0 : p0.registeredComponents), [
              componentsContext,
              props
            ], "p1.registeredComponents||p0?.registeredComponents")
          }
        }, 3, block.id);
      }) : null
    ],
    [_IMMUTABLE]: {
      BlocksWrapper: _fnSignal((p0, p1) => {
        var _a;
        return ((_a = p1.context) == null ? void 0 : _a.BlocksWrapper) || (p0 == null ? void 0 : p0.BlocksWrapper);
      }, [
        builderContext$1,
        props
      ], "p1.context?.BlocksWrapper||p0?.BlocksWrapper"),
      BlocksWrapperProps: _fnSignal((p0, p1) => {
        var _a;
        return p1.BlocksWrapperProps || ((_a = p1.context) == null ? void 0 : _a.BlocksWrapperProps) || (p0 == null ? void 0 : p0.BlocksWrapperProps);
      }, [
        builderContext$1,
        props
      ], "p1.BlocksWrapperProps||p1.context?.BlocksWrapperProps||p0?.BlocksWrapperProps"),
      blocks: _fnSignal((p0) => p0.blocks, [
        props
      ], "p0.blocks"),
      classNameProp: _fnSignal((p0) => p0.className, [
        props
      ], "p0.className"),
      parent: _fnSignal((p0) => p0.parent, [
        props
      ], "p0.parent"),
      path: _fnSignal((p0) => p0.path, [
        props
      ], "p0.path"),
      styleProp: _fnSignal((p0) => p0.styleProp, [
        props
      ], "p0.styleProp")
    }
  }, 1, "0n_1");
}, "Blocks_component_PI1ErWPzPEg"));
export {
  Blocks,
  Blocks as default
};
